import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Back-Up</Title>

                    <section className="mt-2 p-3">

                        <ul>
                            <li>Scout;</li>
                            <li>Axial P.M.;</li>
                            <li>Axial Osso;</li>
                            <li>Sagital P.M.;</li>
                            <li>Sagital Osso;</li>
                            <li>Coronal P.M.;</li>
                            <li>Coronal Osso;</li>
                            <li>3D VR Braço Dir. / Esq.;</li>
                            <li>3D VR Braço Sup. / Inf.;</li>
                            <li>3D MIP Braço Dir. / Esq.;</li>
                            <li>3D MIP Braço Sup. / Inf.</li>
                            <li>Relatório de dose;</li>
                        </ul>
                    </section>
                </div>
            </div>
        </Container>
    )
}